export default defineNuxtPlugin(nuxtApp => {
  const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error) {
      return error.message || 'An unexpected error occurred.';
    }
    if (typeof error === 'string') {
      return error;
    }

    try {
      return JSON.stringify(error) || 'An unexpected error occurred.';
    } catch {
      return 'An unexpected error occurred.';
    }
  };

  nuxtApp.vueApp.config.errorHandler = (err, _instance, info) => {
    (nuxtApp.$sentry as { captureException: (error: unknown) => void }).captureException(err);

    const { dispatchMessage } = useSystemMessages();
    const detail = `${getErrorMessage(err)}`;

    dispatchMessage('Error', 'error', detail, 8000);
    console.error('Vue error captured:', err, info);
  };
});
